import type { JSX } from 'react';
import { TFunction } from 'i18next';
import { IDashboardWidgetCatalogItem } from '../../../types/IDashboardWidgetCatalogItem';
import { WeeklyBalanceWidgetConfiguration } from './WeeklyBalanceWidgetConfiguration';
import { DashboardWidgetType } from '../../../types/DashboardWidgetType';
import { v4 } from 'uuid';
import { BarChart } from '@mui/icons-material';
import { DashboardWidgetCatalogItemImageColorType } from '../../widget-catalog/DashboardWidgetCatalogItemImage';
import { LayoutItem } from 'react-grid-layout';

export class WeeklyBalanceWidgetCatalogItem implements IDashboardWidgetCatalogItem<WeeklyBalanceWidgetConfiguration> {
  title: string;
  description: string;
  icon: JSX.Element;
  iconColor: DashboardWidgetCatalogItemImageColorType;
  id: string;
  type: DashboardWidgetType;
  configuration: WeeklyBalanceWidgetConfiguration;
  layout: LayoutItem;

  constructor(private t: TFunction) {
    this.title = t('dashboard.weeklyBalanceWidget.title');
    this.description = t('dashboard.weeklyBalanceWidget.description');
    this.icon = <BarChart />;
    this.iconColor = 'blue';
    this.id = v4();
    this.type = DashboardWidgetType.WeeklyBalanceWidget;
    this.configuration = new WeeklyBalanceWidgetConfiguration(t);
    this.layout = {
      h: 2,
      w: 3,
      i: v4(),
      x: 0,
      y: 0,
      maxH: 4,
      maxW: 6,
      minH: 2,
      minW: 2,
    };
  }
}
